import { Component } from 'react'

import * as h from 'h'

export default class PublicationsList extends Component {
  render () {
    const { publications, theme } = this.props

    return h.div(h.ca(theme.container),
      h.h2(null, `Publications`),
      publications && publications.length !== 0
        ? h.ul(h.ca(theme.list),
            publications.map(publication => (
              h.li({ key: publication },
                publication))))
        : h.p(null, 'No publications to display.')
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/FacultyView/PublicationsList.js